import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { concatWithDot } from 'helpers/string';

import { IEachUnitFields } from './types';

export const EachUnitFields: FC<IEachUnitFields> = memo(({ name, disabled }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <BorderedCard>
      <Grid container spacing={2} display="flex" alignItems="flex-end">
        <Grid item xs={6}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, PRODUCT_NAMES.NAME)}
            name={concatWithDot(name, PRODUCT_NAMES.NAME)}
            label={t('global.products.name')}
            disabled={disabled}
            maxLength={150}
          />
        </Grid>
        <Grid item xs={6}>
          <NumberInputControlled
            control={control}
            id={concatWithDot(name, PRODUCT_NAMES.COST_PER_UNIT)}
            name={concatWithDot(name, PRODUCT_NAMES.COST_PER_UNIT)}
            label={t('global.products.costPerUnitProduct')}
            adornmentType="currency"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <NumberInputControlled
            control={control}
            id={concatWithDot(name, PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH)}
            name={concatWithDot(name, PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH)}
            label={t('global.products.annualExpenseGrowth')}
            adornmentType="percentage"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <NumberInputControlled
            control={control}
            id={concatWithDot(name, PRODUCT_NAMES.PRICE)}
            name={concatWithDot(name, PRODUCT_NAMES.PRICE)}
            label={t('global.products.price')}
            adornmentType="currency"
            disabled={true}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
